import { getToken } from 'utils/cookies'

const SCRIPT_ID = 'inhouse-chat-script'
// const SCRIPT_SRC = 'https://inhouse-chat.renesriwanto.workers.dev/inhouse-chat.js'
// const SCRIPT_SRC = 'http://localhost:5180/inhouse-chat.js'
const SCRIPT_SRC = 'https://widget.crm.id/inhouse-chat.js'
// Diisi tiap startInhouseChat() dari `endpoint` response inits (domain API company aktif).
let identityTokenUrl = ''

// Tampilkan widget: muat script pertama kali, selanjutnya cukup boot ulang
// (identify() dipanggil lagi, jadi identitas ikut company yang baru).
// `endpoint`: domain API dari response inits, mis. 'register.api.kledo.com'.
export const startInhouseChat = (endpoint) => {
  identityTokenUrl = `https://${endpoint}/api/v1/finance/inhouseChat/identityToken`

  if (document.getElementById(SCRIPT_ID)) {
    window.InhouseChat('boot')
    return
  }

  window.inhouseChatSettings = {
    // appKey & apiBase tidak diset: diambil dari respons identityToken,
    // jadi widget hanya tampil untuk user yang sudah login.
    // Dipanggil setiap kali widget perlu identitas. Baca token DI SINI (bukan sekali di awal),
    // supaya selalu yang terbaru setelah login, logout, atau refresh token.
    identify: () => {
      const token = getToken()
      if (!token) {
        return null
      }
      return fetch(identityTokenUrl, {
        headers: { Authorization: `Bearer ${token}` },
      }).then((r) => (r.ok ? r.json() : null))
    },
  }
  // Antrean: panggilan InhouseChat(...) sebelum script selesai dimuat disimpan dulu.
  window.InhouseChat =
    window.InhouseChat ||
    function inhouseChatQueue(...args) {
      ;(window.InhouseChat.q = window.InhouseChat.q || []).push(args)
    }

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.src = SCRIPT_SRC
  script.async = true
  document.body.appendChild(script)
}

// Hapus widget dari halaman (mis. saat ganti company). Kalau script masih dimuat,
// perintah masuk antrean dan dijalankan begitu script siap.
export const stopInhouseChat = () => {
  if (document.getElementById(SCRIPT_ID)) {
    window.InhouseChat('shutdown')
  }
}
